import React from 'react';
import styled from 'styled-components';
import { useAppSelector, configSelectors, } from '@pomofocus/shared-client';
import { IconSets } from '../../common/IconSets';
import Selections from '../../common/Selections';
import * as colors from '../../../colors';
import { Form } from '../../styles/Form';
import { SectionWrapper, FormBlock, FormHeader, FormHeaderText, FlexWrapper, } from './common';
export const SoundConfig = ({ onChangeAlarmSoundType, onChangeAlarmVolume, onChangeAlarmRepeatTimes, onChangeTickingSoundType, onChangeTickingVolume, onReleaseTickingVolume, alarmSoundSelection, tickingSoundSelection, }) => {
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    return (React.createElement(SectionWrapper, { subHeader: "Sound", SubHeaderIcon: React.createElement(IconSets, { name: "Sound" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Alarm Sound")),
                React.createElement(NotificationWrapper, null,
                    React.createElement(Selections, { selectedId: configObj.alarmSoundType, handleSelect: onChangeAlarmSoundType, selection: alarmSoundSelection, idAttr: "id", textAttr: "text", width: 130, fontSize: 14 }))),
            React.createElement(TickingSliderWrapper, null,
                React.createElement(SliderContainer, null,
                    React.createElement(SliderAmount, null, configObj.soundVolume),
                    React.createElement(VolumeSlider, { type: "range", min: 0, max: 100, value: configObj.soundVolume, onChange: onChangeAlarmVolume, className: "slider", id: "myRange" }))),
            React.createElement(AlarmRepeatTimesWrapper, null,
                "repeat",
                React.createElement(AlarmRepeatTimesForm, { value: configObj.alarmRepeatTimes, onChange: (e) => onChangeAlarmRepeatTimes(Math.floor(e.target.value)), type: "number", min: "1", step: "1" }))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Focus Sound")),
                React.createElement(NotificationWrapper, null,
                    React.createElement(Selections, { selectedId: configObj.tickingSoundType, handleSelect: onChangeTickingSoundType, selection: tickingSoundSelection, idAttr: "id", textAttr: "text", width: 130, fontSize: 14 }))),
            React.createElement(TickingSliderWrapper, null,
                React.createElement(SliderContainer, null,
                    React.createElement(SliderAmount, null, configObj.tickingVolume),
                    React.createElement(VolumeSlider, { type: "range", min: 0, max: 100, value: configObj.tickingVolume, onChange: onChangeTickingVolume, className: "slider", id: "myRange", onMouseUp: onReleaseTickingVolume, onTouchEnd: onReleaseTickingVolume }))))));
};
const NotificationWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const SliderContainer = styled.div `
  display: flex;
  align-items: center;
  width: 50%;
`;
const TickingSliderWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 22px;
`;
const VolumeSlider = styled.input `
  width: 80%;
  background-color: #ccc;
  -webkit-appearance: none;
  border-radius: 50px;
  height: 7px;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 25px;
    height: 25px;
    background: hsla(87, 59%, 49%, 1);
    background: white;
    cursor: pointer;
    border-radius: 50px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  }
  &::-moz-range-thumb {
    -webkit-appearance: none;
    width: 25px;
    height: 25px;
    background: white;
    cursor: pointer;
    border-radius: 50px;
  }
`;
const SliderAmount = styled.div `
  display: inline-block;
  width: 20%;
  text-align: center;
  color: ${colors.FONT_THIRD};
  margin-right: 5px;
`;
const AlarmRepeatTimesWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 22px;
`;
const AlarmRepeatTimesForm = styled(Form) `
  width: 55px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
`;
